import type { OrderFulfillmentStatus } from '@/types/order';

export const FULFILLMENT_SEQUENCE: OrderFulfillmentStatus[] = [
  'EN_PREPARACION',
  'DESPACHADO',
  'EN_CAMINO',
  'ENTREGADO',
];

export function allowedNextFulfillmentStatuses(
  current: OrderFulfillmentStatus,
): OrderFulfillmentStatus[] {
  const i = FULFILLMENT_SEQUENCE.indexOf(current);
  if (i < 0 || i >= FULFILLMENT_SEQUENCE.length - 1) return [];
  return [FULFILLMENT_SEQUENCE[i + 1]];
}
